export default __webpack_public_path__ + "static/explore-50079ca28716aa7f9958030e595150a0.png";